import Columns from '../../../layout/Columns'
import Column from '../../../layout/Column'
import Container from '../../../elements/Container'
import Button from '../../../elements/Button'
import LineSeparator from '../../../elements/LineSeparator'
import styles from './styles.module.scss'
import React from 'react'
import isEmpty from 'lodash-es/isEmpty'
import Image from 'next/image'
import { getS3Url } from '../../../helpers/getS3Url'
import { withModifiers } from '../../../helpers/withModifiers'
import { useResponsive } from '../../../../providers/ResponsiveContext'

const Perks = ({ shadowRef, data }) => {
  const { isSmallMobile, isTablet, isMobile } = useResponsive()
  const hasImage = !!data.image

  return (
    <Container>
      <div ref={shadowRef} className={styles.overlay}></div>

      {isTablet && (
        <Column variant={['no-padding']} spans={isSmallMobile ? 12 : 11}>
          <h2 className={styles.title}>{data.title}</h2>
        </Column>
      )}

      <Columns
        className={withModifiers('columns', [!hasImage && 'wide'], styles)}
        variant={[!hasImage && isTablet ? '-align-end' : '-distribute-between']}
      >
        <Column
          spans={
            isSmallMobile
              ? 11
              : isTablet
              ? !hasImage
                ? 10
                : 8
              : !hasImage
              ? 12
              : 6
          }
        >
          {!isTablet && <h2>{data.title}</h2>}

          <Columns
            variant={[!hasImage && (isTablet ? '-align-end' : '-align-center')]}
          >
            <Column spans={!hasImage && !isTablet ? 1 : 2}>
              <LineSeparator />
            </Column>

            <Column spans={!hasImage && !isTablet ? 6 : 10}>
              {data.description && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.description
                  }}
                ></div>
              )}

              {data.button && (
                <Button
                  className={styles.button}
                  variant={['secondary', 'blue', 'offset-left']}
                  href={data.button.href}
                >
                  {data.button.label}
                </Button>
              )}
            </Column>
          </Columns>
        </Column>

        {data.image && (
          <Column spans={isSmallMobile ? 12 : isTablet ? 4 : 6}>
            <div className={styles.image}>
              <Image
                // layout={!isSmallMobile && isTablet && 'fill'}
                // objectFit="cover"
                // objectPosition={!isSmallMobile && isTablet && 'left'}
                width={486}
                height={365}
                alt="Experience presentation image"
                src={data.image}
              />
            </div>
          </Column>
        )}
      </Columns>

      {data.statistics && !isEmpty(data.statistics) && (
        <Columns variant={['no-gutter', '-distribute-between']}>
          {data.statistics.map((item, index) => (
            <React.Fragment key={index}>
              {data.statistics && (
                <Column variant={['no-padding']} className={styles.option}>
                  <h3 className={styles.option__title}>{item.value}</h3>

                  <h4 className={styles.option__subtitle}>{item.title}</h4>

                  <Image
                    alt={`icon for ${item.value}`}
                    src={getS3Url(item.cloudflare_icon || item.icon)}
                    width={36}
                    height={36}
                  />
                </Column>
              )}

              {isMobile
                ? index % 2 !== 1 && <div className={styles.border}></div>
                : index !== 3 && <div className={styles.border}></div>}
            </React.Fragment>
          ))}
        </Columns>
      )}
    </Container>
  )
}

export default Perks
